//format date to dd.mm.yyyy
export default function formatDateHelper(date) {
  //remove time from date if it exists
  const d = date instanceof Date ? date : new Date(date);

  if (isNaN(d)) return "";

  const day = String(d.getUTCDate()).padStart(2, "0");
  const month = String(d.getUTCMonth() + 1).padStart(2, "0");
  const year = d.getUTCFullYear();

  return `${day}.${month}.${year}`;
}

//format datetime to dd.mm.yyyy HH:mm
export function formatDateTimeHelper(date) {
  const d = date instanceof Date ? date : new Date(date);

  if (isNaN(d)) return "";

  const day = String(d.getDate()).padStart(2, "0");
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const year = d.getFullYear();
  const hours = String(d.getHours()).padStart(2, "0");
  const minutes = String(d.getMinutes()).padStart(2, "0");

  return `${day}.${month}.${year} ${hours}:${minutes}`;
}
